import { Permission, Permissions } from '@src/interfaces/type';

export const ALL_PERMISSION_MAP = {
	GENERAL: {
		CHAT: {
			CREATE: {
				NAME: 'Start New Chats',
				KEY: 'chat_create',
			},
			VIEW: {
				NAME: 'View Chats',
				KEY: 'chat_read',
			},
			UPDATE: {
				NAME: 'Update Chats',
				KEY: 'chat_update',
			},
			DELETE: {
				NAME: 'Delete Chats',
				KEY: 'chat_delete',
			},
		},
		MESSAGE: {
			SEND: {
				NAME: 'Send Messages',
				KEY: 'message_send',
			},
			RECEIVE: {
				NAME: 'Receive Messages',
				KEY: 'message_receive',
			},
			UPDATE: {
				NAME: 'Update Messages',
				KEY: 'message_update',
			},
			DELETE: {
				NAME: 'Delete Messages',
				KEY: 'message_delete',
			},
		},
		ORDER: {
			CREATE: {
				NAME: 'Create New Orders',
				KEY: 'order_create',
			},
			VIEW: {
				NAME: 'View Orders',
				KEY: 'order_read',
			},
			READ_HISTORY: {
				NAME: 'View Order Histories',
				KEY: 'order_read_history',
			},
			UPDATE: {
				NAME: 'Update Orders',
				KEY: 'order_update',
			},
			DELETE: {
				NAME: 'Delete Orders',
				KEY: 'order_delete',
			},
		},
	},
	ORGANIZATION: {
		PERMISSION: {
			ADD: {
				NAME: 'Add User Permissions',
				KEY: 'permission_add',
			},
			REMOVE: {
				NAME: 'Remove User Permissions',
				KEY: 'permission_remove',
			},
		},
		USER: {
			CREATE: {
				NAME: 'Create New Users',
				KEY: 'user_create',
			},
			VIEW: {
				NAME: 'View Users',
				KEY: 'user_read',
			},
			UPDATE: {
				NAME: 'Update Users',
				KEY: 'user_update',
			},
			DELETE: {
				NAME: 'Delete Users',
				KEY: 'user_delete',
			},
		},
		SUPPLIER: {
			CREATE: {
				NAME: 'Create New Supplier Instance',
				KEY: 'supplier_create',
			},
			VIEW: {
				NAME: 'View My Suppliers',
				KEY: 'supplier_read',
			},
			UPDATE: {
				NAME: 'Update Suppliers',
				KEY: 'supplier_update',
			},
			DELETE: {
				NAME: 'Delete Suppliers',
				KEY: 'supplier_delete',
			},
		},
		RESTAURANT: {
			CREATE: {
				NAME: 'Create New Restaurants',
				KEY: 'restaurant_create',
			},
			VIEW: {
				NAME: 'View Restaurants',
				KEY: 'restaurant_read',
			},
			UPDATE: {
				NAME: 'Update Restaurants',
				KEY: 'restaurant_update',
			},
			DELETE: {
				NAME: 'Delete Restaurants',
				KEY: 'restaurant_delete',
			},
		},
	},
	RESTAURANT: {
		ORDER_BOOK: {
			CREATE: {
				NAME: 'Create New Orderbook',
				KEY: 'order_book_create',
			},
			VIEW: {
				NAME: 'View Orderbook',
				KEY: 'order_book_read',
			},
			UPDATE: {
				NAME: 'Update Orderbook',
				KEY: 'order_book_update',
			},
			DELETE: {
				NAME: 'Delete Orderbook',
				KEY: 'order_book_delete',
			},
		},
		CART: {
			SAVE: {
				NAME: 'Save To Cart',
				KEY: 'cart_save',
			},
			VIEW: {
				NAME: 'View Cart',
				KEY: 'cart_read',
			},
			CLEAR: {
				NAME: 'Clear Cart',
				KEY: 'cart_clear',
			},
			UPDATE: {
				NAME: 'Update Cart',
				KEY: 'cart_update',
			},
		},
	},
	SUPPLIER: {
		PRODUCT: {
			CREATE: {
				NAME: 'Create New Products',
				KEY: 'product_create',
			},
			CREATE_CSV: {
				NAME: 'Create New Products (CSV)',
				KEY: 'product_create_csv',
			},
			VIEW: {
				NAME: 'View Products',
				KEY: 'product_read',
			},
			UPDATE: {
				NAME: 'Update Products',
				KEY: 'product_update',
			},
			DELETE: {
				NAME: 'Delete Products',
				KEY: 'product_delete',
			},
		},
		CATALOG: {
			CREATE: {
				NAME: 'Create Catalogs',
				KEY: 'catalog_create',
			},
			VIEW: {
				NAME: 'View Catalogs',
				KEY: 'catalog_read',
			},
			UPDATE: {
				NAME: 'Update Catalogs',
				KEY: 'catalog_update',
			},
			DELETE: {
				NAME: 'Delete Catalogs',
				KEY: 'catalog_delete',
			},
		},
	},
};

export const adminUsers = ['ADMIN', 'SUPER_ADMIN'];
